// Angular import
import { Component, Input, Output, EventEmitter, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DOCUMENTS_RECEIVED_HOME } from 'src/app/demo/documentsReceived/documents-received.models';

@Component({
  selector: 'app-nav-logo',
  templateUrl: './nav-logo.component.html',
  styleUrls: ['./nav-logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class NavLogoComponent implements OnInit {
  @Input() navCollapsed: boolean;
  tenantName = '';
  headerLogo = '';
  readonly home = DOCUMENTS_RECEIVED_HOME;

  ngOnInit() {
    const raw = localStorage.getItem('tenant_config');
    if (raw) {
      try {
        const config = JSON.parse(raw);
        this.tenantName = config.tenant_name ?? config.tenantName ?? '';
        if (config.portal_config) {
          const portalConfig = JSON.parse(config.portal_config);
          this.headerLogo = portalConfig?.headerlogo ?? '';
        }
      } catch {}
    }
  }
}
